import SimpleDelegator from '../simple_delegator';

/**
 * A decorator that adds cancellation support to a FetchRequest via AbortController.
 *
 * Assigns an AbortController signal to the underlying request's options so that
 * the native fetch is canceled at the network level when `cancel()` is called.
 * The perform() promise rejects with a DOMException (name: 'AbortError').
 *
 * @example
 *   const request = new AbortableRequest(new FetchRequest('GET', '/api/data'));
 *   const promise = request.perform();
 *   request.cancel(); // fetch is aborted, promise rejects with AbortError
 *   request.cancel(new Error('timed out')); // promise rejects with that error instead
 */
class AbortableRequest extends SimpleDelegator {
  constructor(request, abortController) {
    if (request.options.signal) {
      throw new Error('cannot use AbortableRequest wrapper on a request that is already abortable');
    }

    super(request);
    this.abortController = abortController || new AbortController();
    this.__target__.options.signal = this.abortController.signal;
  }

  cancel(reason) {
    this.abortController.abort(reason);
  }
}

export default AbortableRequest;
